import { z } from 'zod';

export const atmosConfigSchema = z.object({
  id: z.number({ message: '' }).nullable().optional(),
  terminalId: z.string({ message: '' }),
  houseIds: z
    .array(z.number(), { message: '' })
    .nullable()
    .refine(arg => arg && arg?.length > 0, {
      message: ''
    }),
  isActive: z.boolean({ message: '' }).nullable()
});

export interface IAtmosConfig extends z.infer<typeof atmosConfigSchema> {}
